import { date, number, object, string } from 'yup';

import {
  END_DATE_BEFORE_START_DATE,
  MAX_STRING_LENGTH_YUP_TEMPLATE,
  MUST_BE_NUMBER,
  REQUIRED_FIELD
} from '@/config/text.const';

export interface Fields {
  customerId: string;
  poStatus: string;
  poNumber: string;
  poDate: Date | null;
  poStartDate: Date | null;
  poEndDate: Date | null;
  poTotalValue: number | null;
  poNote: string;
  poCurrency: string;
  customerAccountNumber: string;
}

export type CustomerOption = { label: string; value: string };
export type StatusOption = { label: string; value: string };
export type CurrencyOption = { label: string; value: string };

export const validationSchema = object().shape({
  customerId: string().when('$enableCustomerSelection', {
    is: true,
    then: string().required(REQUIRED_FIELD),
    otherwise: string(),
  }),
  poStatus: string().required(REQUIRED_FIELD),
  poNumber: string().required(REQUIRED_FIELD).max(20, MAX_STRING_LENGTH_YUP_TEMPLATE),
  poStartDate: date().nullable(),
  poEndDate: date()
    .nullable()
    .when('poStartDate', (poStartDate, schema) =>
      poStartDate ? schema.min(poStartDate, END_DATE_BEFORE_START_DATE) : schema,
    ),
  poTotalValue: number()
    .nullable()
    .typeError(MUST_BE_NUMBER)
    .test('max-decimals', 'Must be maximum 4 decimal places', function (value) {
      if (value === undefined || value === null) return true;
      const decimalPlaces = (value.toString().split('.')[1] || '').length;
      return decimalPlaces <= 4;
    })
    .test('positive', 'Value must be positive', function (value) {
      return !value || value > 0;
    }),
  poNote: string().max(200, MAX_STRING_LENGTH_YUP_TEMPLATE),
  poCurrency: string().required(REQUIRED_FIELD),
  customerAccountNumber: string(),
});
